import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

export const ScrollReveal = ({ children, delay = 0, y = 28, className = '' }) => {
  const reduced = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduced ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const GlassPanel = ({ children, className = '', hover = false, ...props }) => (
  <div
    className={`glass rounded-2xl shadow-[0_10px_30px_rgba(0,0,0,0.45)] ${hover ? 'transition-[box-shadow,border-color,transform] duration-200 hover:border-[color:var(--itw-border-strong)] hover:shadow-[0_18px_50px_rgba(0,0,0,0.55)] hover:-translate-y-0.5' : ''} ${className}`}
    {...props}
  >
    {children}
  </div>
);

export const NeonDivider = ({ className = '' }) => (
  <div className={`cyan-divider w-full ${className}`} />
);
